'use client';
import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {SocialPlatform} from '@/_application/core/types';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import React, {useEffect} from 'react';

const FacebookIcon = getImageAssetUrl('icons/facebook-icon.png');
const TwitterIcon = getImageAssetUrl('icons/twitter-icon.png');
const MessengerIcon = getImageAssetUrl('icons/messenger-icon.png');

interface ShareSocialButtonProps {
    platform: SocialPlatform;
    url?: string;
    icon?: string;
}

const ShareSocialButton: React.FC<ShareSocialButtonProps> = ({platform, url, icon}) => {
    const [currentPageUrl, setCurrentPageUrl] = React.useState<string>('');
    const finalUrl = url ?? currentPageUrl;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setCurrentPageUrl(window.location.href);
        }
    }, []);
    const getShareLink = () => {
        switch (platform) {
            case SocialPlatform.Messenger:
                return `https://www.facebook.com/share.php?u=${finalUrl}`;
            case SocialPlatform.Facebook:
                return `https://www.facebook.com/share.php?u=${finalUrl}`;
            case SocialPlatform.Twitter:
                return `https://twitter.com/share?&url=${finalUrl}`;
            default:
                return '#';
        }
    };

    const getIcon = () => {
        const defaultIcons = {
            messenger: MessengerIcon,
            facebook: FacebookIcon,
            twitter: TwitterIcon,
        };

        return icon ?? defaultIcons[platform];
    };

    return (
        <Link href={getShareLink()} target="_blank">
            <Image
                src={getIcon()}
                alt={platform}
                width={24}
                height={24}
                className="h-5 w-5 cursor-pointer md:h-6 md:w-6 md:transition-opacity md:hover:opacity-80"
            />
        </Link>
    );
};

export default ShareSocialButton;
